import React from 'react';
import { Button } from '@/components/ui/button';
import { UserPlus } from 'lucide-react';

interface EngagementSectionProps {
  onInvite: () => void;
}

const EngagementSection: React.FC<EngagementSectionProps> = ({ onInvite }) => {
  return (
    <section className="py-20 sm:py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-fuchsia-600 via-purple-700 to-rose-500 px-8 sm:px-14 py-16 sm:py-20 text-center shadow-2xl">
          {/* Decorative blobs */}
          <div aria-hidden className="absolute -top-24 -left-20 w-72 h-72 rounded-full bg-white/10 blur-3xl" />
          <div aria-hidden className="absolute -bottom-32 -right-20 w-80 h-80 rounded-full bg-pink-300/20 blur-3xl" />

          <div className="relative">
            <img
              src="/brand/kinscircle-tree-icon.png"
              alt="KinsCircle"
              className="w-16 h-16 rounded-2xl shadow-lg mx-auto mb-6"
            />
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5">
              Your Family is Waiting.
            </h2>

            <p className="text-lg md:text-xl text-fuchsia-50/90 max-w-2xl mx-auto leading-relaxed mb-9">
              Bring everyone you love — partners, in-laws, step-family, every
              generation — into one private space, and start building your
              living family story together.
            </p>

            <Button
              onClick={onInvite}
              size="lg"
              className="bg-white text-fuchsia-700 hover:bg-fuchsia-50 rounded-full px-8 h-12 font-semibold shadow-xl"
            >
              <UserPlus className="mr-2 w-4 h-4" />
              Invite Family
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EngagementSection;
